import {request} from '@/lib/request'

function locationServiceIndexPath() {
  return `/wp/v2/location_services`
}

export function listLocationServices() {
  return request('get', locationServiceIndexPath())
}
